import React from "react";
import { useRouteMatch } from "react-router";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import { CollectionView } from "./components/collectionView";

import "./App.css";
import { BackupView } from "./components/backupView";
import { useDefinitions } from "./providers/DefinitionProvider";
import packageJson from '../package.json';

const MenuItem = ({ to, children, context }) => {
  let match = useRouteMatch(to);
  const isActive = to === match?.url ? "active" : "";
  const className = `nav-item ${isActive} ${context}`;
  return (
    <li className={className}>
      <Link to={to}>{children}</Link>
    </li>
  );
};

export function App() {
  const defs = useDefinitions().__specs__;

  const collections = Object.values(defs).map((it: any) => `${it.collection}`);

  return (
    <Router>
      <div className="app-container container-flex">
        <div className="header">
          <h2>Test Plan Editor</h2>
          <div className="version-badge">{packageJson.version}</div>
          </div>
        <div className="row" style={{ paddingTop: "1em" }}>
          <nav className="navbar navbar-default">
            <ul className="navbar-default nav navbar-nav">
              <MenuItem to="/" context={""}>
                Home
              </MenuItem>
              <li>
                <label className="boAdapter">BO Adapter</label>
              </li>
              {Object.values(defs)
                .filter((it: any) => it.context === "boAdapter")
                .map((it: any) => (
                  <MenuItem
                    to={`/${it.collection}`}
                    key={it.collection}
                    context={it.context}
                  >
                    {it.displayName}
                  </MenuItem>
                ))}
              <li>
                <label className="divasdk">Diva SDK</label>
              </li>
              {Object.values(defs)
                .filter((it: any) => it.context === "divasdk")
                .map((it: any) => (
                  <MenuItem
                    to={`/${it.collection}`}
                    key={it.collection}
                    context={it.context}
                  >
                    {it.displayName}
                  </MenuItem>
                ))}
              {Object.values(defs)
                .filter((it: any) => it.context === "legacy")
                .map((it: any) => (
                  <MenuItem
                    to={`/${it.collection}`}
                    key={it.collection}
                    context={it.context}
                  >
                    {it.displayName}
                  </MenuItem>
                ))}
              <MenuItem to={`/backup`} key="backup" context={""}>
                Backup
              </MenuItem>
            </ul>
          </nav>
        </div>

        <Switch>
          <Route
            path="/backup"
            render={({ match }) => (
              <BackupView key="backup" collections={collections} />
            )}
          />
          <Route
            path="/:collectionName/:current"
            render={({ match }) => (
              <CollectionView key={match.params.collectionName} />
            )}
          />
          <Route
            path="/:collectionName"
            render={({ match }) => (
              <CollectionView key={match.params.collectionName} />
            )}
          />
          <Route exact path="/">
            <h4>Welcome to the DIVA Player Test Plan Editor!</h4>
            <p>
              This application is designed for seamless testing of the DIVA
              Player and its advanced functionalities, empowering developers and
              testers to evaluate both the DIVA Player as SDK and the one
              integrated with the DIVA BO Adapter (to stream video content
              directly from DIVA BO as the source).
            </p>
            <p>
              This makes it the perfect tool for developers and testers who need
              comprehensive insights into the player’s performance, quality, and
              integration potential.
            </p>
            <p>
              Start exploring the features, and ensure your DIVA Player
              implementation is optimized for the best streaming experience!
            </p>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
